import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    items: [],
    loaded: false,
    loading: false,
    error: null,
};
const collectionsSlice = createSlice({
    name: 'collections',
    initialState,
    reducers: {
        setCollectionsLoading: (state, action) => {
            state.loading = action.payload;
        },
        storeAllCollections: (_state, action) => ({
            items: action.payload,
            loaded: true,
            loading: false,
            error: null,
        }),
        setCollectionsError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearCollectionsError: (state) => {
            state.error = null;
        },
    },
});
export const { setCollectionsLoading, storeAllCollections, setCollectionsError, clearCollectionsError, } = collectionsSlice.actions;
export default collectionsSlice.reducer;
